var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432.77,110.23l-2.21-3.64c-18.62-30.68-52.28-49.18-87.78-46.94a93.29,93.29,0,0,0-13.59,1.87c-32.27,6.91-60.35,31.31-72,62.56-6.84,18.39-8.75,39.55-21.74,54.14-16.91,19-45.61,19.58-70.85,18.8s-54-.12-70.77,18.94C83.3,227.9,80,244.88,80.8,260.87c2.25,42.33,31.75,80.18,69.26,99s81.68,20.5,122.73,12.23c57.52-11.6,112.21-43.44,145.09-92.61S459.07,163.31,432.77,110.23Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 203.82,
    y: 52.83,
    width: 158.48,
    height: 328.83,
    rx: 25.37,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.93,381.66l2.4-.15c.79-.1,1.77-.25,2.92-.46l1.84-.48c.66-.17,1.33-.47,2.06-.72a25,25,0,0,0,9.34-6.43,23.81,23.81,0,0,0,4.11-6,24.2,24.2,0,0,0,2.37-7.91,90.65,90.65,0,0,0,.22-9.3q0-4.91,0-10.28c0-7.17,0-15,0-23.32,0-16.73,0-35.79,0-56.85,0-42.12,0-92.27-.06-148V90.67c0-3.56,0-7.15,0-10.75,0-.9,0-1.81-.05-2.7a17.1,17.1,0,0,0-.24-2.67l-.21-1.34c-.09-.43-.22-.87-.32-1.3s-.22-.88-.35-1.31l-.47-1.27a24.77,24.77,0,0,0-5.88-9,25.29,25.29,0,0,0-9.25-5.76,24.76,24.76,0,0,0-5.38-1.26c-.91-.13-1.84-.12-2.77-.18s-1.87,0-2.81,0H229.21a25.58,25.58,0,0,0-11.46,2.77,24.83,24.83,0,0,0-8.88,7.62,24.42,24.42,0,0,0-4.45,10.74l-.22,1.44-.07,1.46c-.07,1,0,2,0,2.94v5.88q0,23.48,0,46.23c0,30.31,0,59.54,0,87.39s0,54.31,0,79.08q0,18.57,0,35.84c0,5.74,0,11.38,0,16.89a73.1,73.1,0,0,0,.22,8.14,24,24,0,0,0,2.23,7.57,23.65,23.65,0,0,0,4.33,6.38,25.07,25.07,0,0,0,12.72,7.36,12.11,12.11,0,0,0,1.78.33,13.55,13.55,0,0,0,1.78.23c1.19.07,2.38.13,3.57.11l26.8,0,42.91,0,27.13.05,7,0,2.4,0-2.4,0-7,0-27.13.05-42.91,0-26.8,0c-1.19,0-2.39,0-3.6-.1-.6,0-1.2-.16-1.8-.23a13.92,13.92,0,0,1-1.8-.34,25.45,25.45,0,0,1-6.93-2.7,24.74,24.74,0,0,1-6-4.75,23.9,23.9,0,0,1-4.4-6.46,24.35,24.35,0,0,1-2.27-7.68,74.39,74.39,0,0,1-.24-8.19V334.48q0-17.25,0-35.84c0-24.77,0-51.23,0-79.08s0-57.08,0-87.39V80.06c0-1,0-2,.05-3l.08-1.49.22-1.47a24.93,24.93,0,0,1,4.54-11,25.52,25.52,0,0,1,9.07-7.78,26.27,26.27,0,0,1,11.69-2.83H334.32c.94,0,1.88,0,2.82,0s1.89.06,2.82.19a25.65,25.65,0,0,1,14.92,7.16,25.36,25.36,0,0,1,6,9.23l.47,1.29c.14.44.24.89.36,1.33s.23.89.33,1.34l.21,1.35a19.37,19.37,0,0,1,.25,2.73c.06.92,0,1.82.05,2.72,0,3.6,0,7.19,0,10.75v21.14c0,55.69,0,105.84-.06,148,0,21.06,0,40.12,0,56.85,0,8.36,0,16.15,0,23.32q0,5.37,0,10.28a91.07,91.07,0,0,1-.24,9.32,24,24,0,0,1-2.41,8,24.63,24.63,0,0,1-4.15,6,25,25,0,0,1-9.42,6.41c-.74.25-1.41.55-2.07.71l-1.85.47c-1.16.21-2.15.35-2.93.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.07,72.3a64.38,64.38,0,0,1-11.56,0,64.38,64.38,0,0,1,11.56,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.07,76.07a64.38,64.38,0,0,1-11.56,0,64.38,64.38,0,0,1,11.56,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.07,79.84a64.38,64.38,0,0,1-11.56,0,64.38,64.38,0,0,1,11.56,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.26,79.84v-4l-2,3.31h-.36l-2-3.28v3.94h-.75V74.4h.64l2.27,3.82,2.24-3.82H268v5.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.18,75.72l-2,4.54c-.36.87-.84,1.14-1.47,1.14a1.55,1.55,0,0,1-1.06-.38l.32-.56a1.07,1.07,0,0,0,.74.3c.36,0,.58-.16.79-.64l.13-.28-1.82-4.12h.78L271,79l1.42-3.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.48,76.29c0,1.19-.86,1.9-2.28,1.9h-1.34v1.65h-.78V74.4h2.12C279.62,74.4,280.48,75.11,280.48,76.29Zm-.78,0c0-.77-.52-1.22-1.52-1.22h-1.32v2.45h1.32C279.18,77.52,279.7,77.07,279.7,76.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.66,75.68v.72h-.18a1.22,1.22,0,0,0-1.29,1.39v2h-.75V75.72h.71v.69A1.59,1.59,0,0,1,283.66,75.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.15,77.78a2.15,2.15,0,1,1,2.15,2.11A2.05,2.05,0,0,1,284.15,77.78Zm3.54,0a1.39,1.39,0,1,0-1.39,1.46A1.36,1.36,0,0,0,287.69,77.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.94,74a1.41,1.41,0,0,1,.84.24l-.22.57a1,1,0,0,0-.58-.19c-.44,0-.67.25-.67.72v.36h1.2v.61h-1.18v3.51h-.75V76.33h-.7v-.61h.7v-.37A1.24,1.24,0,0,1,290.94,74Zm1.77.42a.5.5,0,0,1,.51-.49.49.49,0,1,1,0,1A.5.5,0,0,1,292.71,74.44Zm.13,1.28h.75v4.12h-.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,74.07h.75v5.77H295Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.89,78h-3.34A1.39,1.39,0,0,0,299,79.24a1.55,1.55,0,0,0,1.19-.5l.41.48a2,2,0,0,1-1.62.67,2.07,2.07,0,0,1-2.22-2.11,2,2,0,0,1,2.07-2.1,2,2,0,0,1,2,2.12A1.79,1.79,0,0,1,300.89,78Zm-3.34-.54h2.64a1.29,1.29,0,0,0-1.32-1.18A1.27,1.27,0,0,0,297.55,77.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 186.75,
    width: 52.63,
    height: 3.12,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.73,194.92c0,.15-20.5.27-45.79.27s-45.8-.12-45.8-.27,20.5-.26,45.8-.26S330.73,194.78,330.73,194.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.35,
    cy: 227.47,
    r: 15.6,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.98,
    cy: 227.47,
    r: 15.6,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.61,
    cy: 227.47,
    r: 15.6,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.86,250c0,.14-8.74.26-19.51.26s-19.5-.12-19.5-.26,8.73-.26,19.5-.26S256.86,249.82,256.86,250Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.94,250c0,.14-7.59.26-17,.26s-17-.12-17-.26,7.59-.26,17-.26S299.94,249.82,299.94,250Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.22,250c0,.14-7.59.26-17,.26s-16.95-.12-16.95-.26,7.59-.26,16.95-.26S344.22,249.82,344.22,250Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.33,303.62s0-.23,0-.66,0-1.07,0-1.9c0-1.68,0-4.15,0-7.35,0-6.42-.05-15.75-.09-27.53l.16.16-126.69.1h0l.26-.26v37.44l-.26-.25,90.53.11,26.54.07,7.14,0h1.85l.64,0-.61,0H343.9l-7.08,0-26.49.08-90.7.11h-.25v-.25c0-11.92,0-24.51,0-37.44v-.26h.27l126.69.09h.17v.17c0,11.82-.07,21.19-.09,27.62,0,3.19,0,5.65,0,7.32,0,.82,0,1.44,0,1.88S346.33,303.62,346.33,303.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.56,278.1c0,.14-24.35.26-54.4.26s-54.4-.12-54.4-.26,24.35-.26,54.4-.26S337.56,278,337.56,278.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.56,285.51c0,.15-24.35.26-54.4.26s-54.4-.11-54.4-.26,24.35-.26,54.4-.26S337.56,285.37,337.56,285.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.56,292.93c0,.14-24.35.26-54.4.26s-54.4-.12-54.4-.26,24.35-.26,54.4-.26S337.56,292.79,337.56,292.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.33,350.6s0-.22,0-.65,0-1.08,0-1.91c0-1.68,0-4.15,0-7.35,0-6.41-.05-15.75-.09-27.53l.16.17-126.69.09h0l.26-.26V350.6l-.26-.25,90.53.12,26.54.07,7.14,0,1.85,0h.64s-.2,0-.61,0l-1.82,0-7.08,0-26.49.07-90.7.12h-.25v-.26c0-11.92,0-24.5,0-37.44v-.26h.27l126.69.1h.17v.16c0,11.82-.07,21.2-.09,27.63,0,3.19,0,5.64,0,7.32,0,.81,0,1.44,0,1.87S346.33,350.6,346.33,350.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.56,325.08c0,.15-24.35.26-54.4.26s-54.4-.11-54.4-.26,24.35-.26,54.4-.26S337.56,324.94,337.56,325.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.56,332.5c0,.14-24.35.26-54.4.26s-54.4-.12-54.4-.26,24.35-.26,54.4-.26S337.56,332.35,337.56,332.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.56,339.91c0,.15-24.35.26-54.4.26s-54.4-.11-54.4-.26,24.35-.26,54.4-.26S337.56,339.77,337.56,339.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.34,79.85h.19l.53,0,1.94,0-.06.06c0-.43,0-.9,0-1.41,0-.26,0-.51,0-.81a.74.74,0,0,1,.65-.6c.32,0,.59,0,.93,0a.76.76,0,0,1,.64.75c0,.65,0,1.34,0,2l-.09-.09,2.45,0-.1.09c0-1,0-2,0-3.05,0-.26,0-.52,0-.78a.77.77,0,0,0-.34-.57L227,74.33l-1-1-.5-.49c-.17-.17-.3-.34-.5-.38a.65.65,0,0,0-.56.11c-.15.12-.31.3-.46.45s-.59.6-.88.88c-.55.58-1.13,1.1-1.54,1.6a1.75,1.75,0,0,0-.13.91v.86c0,.53,0,1,0,1.39s0,.65,0,.89a1.73,1.73,0,0,1,0,.32s0-.1,0-.3,0-.52,0-.87,0-.87,0-1.4c0-.28,0-.57,0-.88v-.48a1,1,0,0,1,.14-.51c.45-.56,1-1,1.55-1.64l.87-.89c.16-.16.29-.31.47-.47a.86.86,0,0,1,.71-.14,1.35,1.35,0,0,1,.59.42l.5.49,1,1,1.07,1a1.59,1.59,0,0,1,.27.3.74.74,0,0,1,.13.41c0,.26,0,.52,0,.78,0,1,0,2.06,0,3.05v.09h-.09l-2.45,0H226v-.09c0-.71,0-1.4,0-2a.6.6,0,0,0-.49-.6h-.89a.6.6,0,0,0-.53.48c0,.24,0,.53,0,.78v1.46h-2.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281.03,
    cy: 136.87,
    r: 39.55,
    transform: "translate(84.21 379.71) rotate(-76.94)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.71,141.09a7.53,7.53,0,0,0-5.27-12.42,8,8,0,0,0-8.78-10.57,8.64,8.64,0,0,0-12-7.38,8.32,8.32,0,0,0-13.25.52l-2.08.11a12.72,12.72,0,0,0-9.37,4.67,2.88,2.88,0,0,1-.4.44c-2,1.87-4.1,3.87-4.81,6.52-.79,2.94.26,6.32-1.23,9-.58,1.05-1.53,1.9-1.92,3-.75,2.15.7,4.47.53,6.74s-2.17,4.5-1.93,6.9a6.36,6.36,0,0,0,2.9,4.17,24.94,24.94,0,0,1,4.15,3.18c.92,1,1.52,2.35,2.42,3.42a7.84,7.84,0,0,0,10.66.82,8.34,8.34,0,0,0,7.54,1.32,24.45,24.45,0,0,0,7.06-3.61,4.82,4.82,0,0,0,8.1-.49c.56,1.75,2.64,2.64,4.47,2.46a12.33,12.33,0,0,0,5-2.13c2.94-1.81,6.22-4.2,6.3-7.65.05-2.11-1.17-4.29-.37-6.24A11.44,11.44,0,0,1,312.71,141.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.9,128c-.66-1.8-.37-3.8-.62-5.7-.54-4.2-3.81-7.74-7.75-9.28a18.51,18.51,0,0,0-12.44.07,17.25,17.25,0,0,0-7.88,5,13.13,13.13,0,0,0-2.57,11.78L283.1,127a24,24,0,0,0,6.44,4.36,4.42,4.42,0,0,0,2.23.38,2,2,0,0,0,1.68-1.35A4.2,4.2,0,0,0,292.9,128Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.21,123.19,271.56,119c-5.95-.48-9.71,6.93-9.93,12.9-.25,6.63-.28,14.73.63,19.64,1.83,9.89,9.48,10.95,9.48,10.95s0,6.76.17,10.36c6.75,3.21,13.69,2.75,20.77-.41l.74-45.78A3.48,3.48,0,0,0,290.21,123.19Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.5,138.05a1.28,1.28,0,0,0,1.26,1.25,1.23,1.23,0,0,0,1.29-1.18,1.28,1.28,0,0,0-1.26-1.25A1.22,1.22,0,0,0,265.5,138.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.49,136.05c.17.16,1.11-.57,2.48-.61s2.39.63,2.54.46-.1-.37-.54-.68a3.5,3.5,0,0,0-4,.12C263.55,135.68,263.41,136,263.49,136.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.49,138.05a1.27,1.27,0,0,0,1.26,1.25,1.21,1.21,0,0,0,1.28-1.18,1.27,1.27,0,0,0-1.26-1.25A1.21,1.21,0,0,0,278.49,138.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,136c.16.16,1.11-.58,2.48-.61s2.39.63,2.53.45-.09-.37-.54-.67a3.44,3.44,0,0,0-2-.57,3.3,3.3,0,0,0-2,.69C277,135.58,276.89,135.89,277,136Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.26,146.25a8.77,8.77,0,0,0-2.24-.35c-.35,0-.68-.08-.74-.32a1.74,1.74,0,0,1,.2-1c.31-.86.63-1.76,1-2.69a46.06,46.06,0,0,0,2.14-7,45.29,45.29,0,0,0-2.7,6.84l-.92,2.7a2,2,0,0,0-.15,1.38.89.89,0,0,0,.59.5,2.15,2.15,0,0,0,.59.06A8.9,8.9,0,0,0,272.26,146.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.74,162.48a25.23,25.23,0,0,0,13.2-3.89s-3.17,7-13.13,6.29Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.93,149.53a2.46,2.46,0,0,1,2.18-1,2.26,2.26,0,0,1,1.58.79,1.41,1.41,0,0,1,.15,1.63,1.66,1.66,0,0,1-1.78.51,5.33,5.33,0,0,1-1.78-1,1.69,1.69,0,0,1-.4-.4.45.45,0,0,1,0-.51",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.32,147.09c-.23,0-.19,1.48-1.44,2.57s-2.83,1-2.83,1.17.36.28,1,.28a3.71,3.71,0,0,0,2.37-.89,3.2,3.2,0,0,0,1.1-2.15C276.59,147.44,276.42,147.08,276.32,147.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.63,131.82c.15.37,1.51.16,3.12.31s2.92.56,3.13.22c.09-.16-.14-.51-.68-.86a5.37,5.37,0,0,0-2.33-.75,5.27,5.27,0,0,0-2.43.35C276.86,131.35,276.57,131.65,276.63,131.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.74,130.05c.25.31,1.18,0,2.32-.09s2.1.16,2.31-.17c.09-.16-.07-.47-.5-.75a3.15,3.15,0,0,0-1.89-.47,3.27,3.27,0,0,0-1.84.68C263.75,129.58,263.63,129.9,263.74,130.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.37,125.15c-1.87-5.72-10.24-13.59-16.24-13.13l-9.54,5.82a9.25,9.25,0,0,0,6.33,7c1.7.51,3.74.63,4.75,2.08s.46,3.66,1.43,5.18c1.34,2.12,5,2,6,4.29.44,1,.22,2.2.68,3.2.62,1.32,4,3,5.38,2.53s1.37-2.82,1.82-4.06a6.62,6.62,0,0,0,.17-4.41C296.5,130.88,297.26,127.88,296.37,125.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.13,139.72c-.05,0,.15-.51.3-1.44a9,9,0,0,0-.31-3.93,8.42,8.42,0,0,0-3.41-4.6,27.84,27.84,0,0,0-3.14-1.56,9.46,9.46,0,0,1-3.21-2.17,14.7,14.7,0,0,1-1.86-3.38,8.4,8.4,0,0,0-7.35-4.87,8.75,8.75,0,0,0-3.86.79c-.87.38-1.29.71-1.32.67s.09-.11.29-.26a6.26,6.26,0,0,1,.94-.6,8.51,8.51,0,0,1,3.95-1,8.6,8.6,0,0,1,5.63,2.13,8.89,8.89,0,0,1,2.18,2.88,13.78,13.78,0,0,0,1.8,3.26,8.73,8.73,0,0,0,3,2.06,25.61,25.61,0,0,1,3.18,1.62,8.82,8.82,0,0,1,3.66,9,6,6,0,0,1-.33,1.07C295.21,139.61,295.15,139.73,295.13,139.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.22,129.09c-.05,0-.22-.35-.74-.86a8.89,8.89,0,0,0-2.62-1.61,21,21,0,0,1-2-1A5.83,5.83,0,0,1,287,124c-1.07-1.5-1.41-3.5-2.83-4.88a8.55,8.55,0,0,0-4.89-2.36,11.48,11.48,0,0,0-4.53.36,33.71,33.71,0,0,0-4,1.54,3.85,3.85,0,0,1,1-.64,14.53,14.53,0,0,1,2.91-1.26,11.31,11.31,0,0,1,4.69-.47,8.77,8.77,0,0,1,5.2,2.47c1.54,1.52,1.88,3.6,2.85,5a9.23,9.23,0,0,0,3.65,2.61,8,8,0,0,1,2.61,1.8,3.15,3.15,0,0,1,.49.72C294.2,129,294.24,129.08,294.22,129.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,143.35c0-.74.79-2.5,1.52-2.63,1.94-.36,5.46-.29,5.62,4.66.22,6.76-6.62,5.59-6.63,5.4S291.1,145.91,291,143.35Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.53,148.14s.12.08.32.17a1.21,1.21,0,0,0,.88,0,2.91,2.91,0,0,0,1.27-2.66,3.78,3.78,0,0,0-.39-1.68,1.35,1.35,0,0,0-.91-.88.62.62,0,0,0-.69.35c-.08.19,0,.32-.07.34s-.15-.11-.1-.39a.72.72,0,0,1,.25-.44.91.91,0,0,1,.64-.19,1.65,1.65,0,0,1,1.27,1,3.93,3.93,0,0,1,.47,1.87c0,1.37-.65,2.67-1.62,3a1.28,1.28,0,0,1-1.09-.14C293.55,148.31,293.51,148.16,293.53,148.14Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.49,149.81c.1-.14.33-.21.66-.07a1.78,1.78,0,0,1,.88,1.14,2.45,2.45,0,0,1-.54,2.3,3,3,0,0,1-2.75.92,3,3,0,0,1-2.2-1.87,2.71,2.71,0,0,1,.09-2.23,1.7,1.7,0,0,1,1.2-.93c.39,0,.58.14.6.31a2.29,2.29,0,0,1-.08.56,2.29,2.29,0,0,0,0,.63,1.86,1.86,0,0,0,.33.64.87.87,0,0,0,.51.33,1.16,1.16,0,0,0,.59-.07.68.68,0,0,0,.39-.41C296.42,150.61,296.3,150.11,296.49,149.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.06,172.11l8.79-1.53,20.87-.75,9.45.47S284,182.9,263.06,172.11Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.58,136.87s0-.22-.06-.64-.06-1.07-.12-1.88c0-.41,0-.87-.08-1.38s-.16-1.06-.25-1.65-.2-1.24-.31-1.93a20.05,20.05,0,0,0-.51-2.15,37.81,37.81,0,0,0-4.38-10.49,39.25,39.25,0,0,0-10-11.17l-1.7-1.27c-.6-.39-1.23-.75-1.85-1.14s-1.24-.8-1.92-1.11l-2.05-1-1-.5-1.1-.39L293,99.39c-.75-.25-1.54-.41-2.32-.62a18.68,18.68,0,0,0-2.38-.54,35.15,35.15,0,0,0-5-.57c-.85,0-1.7-.12-2.56-.1l-2.61.13c-.43,0-.87,0-1.31.09l-1.31.2c-.88.14-1.77.25-2.65.43a43.42,43.42,0,0,0-10.37,3.79c-.83.45-1.62,1-2.44,1.46-.4.26-.83.48-1.22.77l-1.15.87a41.79,41.79,0,0,0-4.46,3.79,44.47,44.47,0,0,0-3.85,4.55l-.91,1.21-.79,1.29-.79,1.3a11.59,11.59,0,0,0-.73,1.34c-.44.92-.89,1.85-1.33,2.78s-.71,1.93-1.07,2.91a38.86,38.86,0,0,0,0,24.79c.35,1,.71,2,1.06,2.91s.89,1.86,1.34,2.78l.33.68.4.66.79,1.3.79,1.29.9,1.21a43.44,43.44,0,0,0,3.86,4.56,45.28,45.28,0,0,0,4.45,3.79l1.16.87a13.83,13.83,0,0,0,1.22.76c.82.49,1.61,1,2.44,1.47a43.65,43.65,0,0,0,5.13,2.25,42.19,42.19,0,0,0,5.24,1.54c.88.18,1.77.28,2.65.43l1.31.2c.44.06.88,0,1.31.08l2.61.14c.86,0,1.71-.07,2.56-.1a36.68,36.68,0,0,0,5-.57,22.87,22.87,0,0,0,2.38-.54c.78-.21,1.57-.37,2.32-.62l2.22-.81,1.09-.4,1-.49,2-1c.68-.31,1.28-.75,1.92-1.11s1.25-.74,1.85-1.13l1.7-1.27a39.23,39.23,0,0,0,10-11.17,38.05,38.05,0,0,0,4.38-10.49,20.21,20.21,0,0,0,.51-2.16c.11-.68.22-1.32.31-1.92s.2-1.15.25-1.65.06-1,.08-1.38c.06-.82.1-1.44.12-1.88s.06-.64.06-.64,0,.22,0,.64,0,1.07-.07,1.88c0,.42,0,.88-.06,1.39s-.14,1.06-.23,1.66-.18,1.25-.28,1.94a18.52,18.52,0,0,1-.5,2.17,37.09,37.09,0,0,1-4.32,10.59,39.55,39.55,0,0,1-10,11.31l-1.72,1.29c-.6.4-1.23.76-1.86,1.15s-1.25.81-1.94,1.13l-2.06,1-1,.5-1.11.4-2.23.82c-.76.26-1.55.42-2.34.64a21.59,21.59,0,0,1-2.41.55,37.42,37.42,0,0,1-5,.6c-.86,0-1.73.11-2.6.1l-2.63-.13c-.44,0-.89,0-1.33-.08l-1.33-.2c-.88-.15-1.78-.25-2.67-.43A43.94,43.94,0,0,1,262.28,172c-.84-.46-1.64-1-2.48-1.48-.41-.26-.84-.48-1.23-.78l-1.17-.87a44.14,44.14,0,0,1-4.52-3.84,44.65,44.65,0,0,1-3.91-4.61l-.91-1.22-.81-1.31-.8-1.32-.4-.66-.34-.7-1.35-2.8c-.36-1-.72-2-1.09-2.95a39.44,39.44,0,0,1,0-25.13l1.08-3,1.35-2.8a9.43,9.43,0,0,1,.75-1.36l.8-1.32.8-1.31.92-1.22a36.14,36.14,0,0,1,8.42-8.44l1.17-.88c.39-.29.83-.51,1.23-.77.84-.5,1.64-1,2.48-1.48a39.58,39.58,0,0,1,5.2-2.27A41.11,41.11,0,0,1,272.79,98c.89-.18,1.79-.29,2.67-.43l1.33-.2c.44-.06.89-.06,1.33-.09l2.63-.12c.87,0,1.74.07,2.59.1a37.37,37.37,0,0,1,5,.6,17.9,17.9,0,0,1,2.41.55c.78.21,1.58.38,2.34.63l2.23.82,1.1.41,1.05.5,2.06,1c.69.31,1.3.76,1.94,1.12s1.26.76,1.86,1.16l1.71,1.28a39.35,39.35,0,0,1,10.05,11.32,37.38,37.38,0,0,1,4.32,10.59,17.64,17.64,0,0,1,.5,2.17c.1.69.2,1.33.28,1.94s.19,1.15.23,1.66,0,1,.06,1.38c0,.82.05,1.44.07,1.89S320.58,136.87,320.58,136.87Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M444.77,388.76a21.07,21.07,0,0,0-34.53,8.29l2.5,9.67c.95-3.29,3-6.48,6.13-7.83s7.06-.61,10.41.61,6.64,2.84,10.19,3.06,7.58-1.47,8.64-4.87C449.11,394.5,447.18,391.09,444.77,388.76Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M444.77,388.76a21.07,21.07,0,0,0-34.53,8.29l2.5,9.67c.95-3.29,3-6.48,6.13-7.83s7.06-.61,10.41.61,6.64,2.84,10.19,3.06,7.58-1.47,8.64-4.87C449.11,394.5,447.18,391.09,444.77,388.76Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M384.56,421c-5.22-5-5-13.59-2.36-20.3s8.29-11.87,14.63-15.26a46.32,46.32,0,0,1,40.38-1.31,19.16,19.16,0,0,0-15.49,9.1c-2.86,4.75-3.5,10.51-5.86,15.53A24.46,24.46,0,0,1,384.56,421",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.05,391.22c-5.78-6.82-6.55-17.77-5.7-26.66s2.91-17.86,1.51-26.68c-.83-5.23-2.86-10.23-3.54-15.48s.28-11.19,4.35-14.58c4.68-3.89,12-3,16.9.69s7.69,9.4,9.75,15.13c4.52,12.58,6.18,26.53,2.47,39.38s-12.44,24.32-25.24,28.2",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.27,447.18a6.81,6.81,0,0,1,0-.79c0-.51,0-1.27.05-2.25.07-2,.26-4.79.7-8.26a108.46,108.46,0,0,1,2.22-12.1,55.28,55.28,0,0,1,5.52-14,57.84,57.84,0,0,1,9-12.06,57.24,57.24,0,0,1,9.45-7.86c1.44-1,2.84-1.76,4-2.46s2.31-1.18,3.19-1.6l2.08-.88a4.36,4.36,0,0,1,.74-.27,6.72,6.72,0,0,1-.7.36l-2,.95c-.86.45-1.92,1-3.14,1.67s-2.56,1.5-4,2.51A59.47,59.47,0,0,0,388.15,410c-5.31,9.29-6.76,19.06-7.82,25.91-.48,3.46-.72,6.28-.85,8.23-.05.94-.1,1.69-.13,2.24A3.78,3.78,0,0,1,379.27,447.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.44,364.32c-10.69,6.45-10.66,12.32-8.87,17.86s8.35,9.39,13.78,7.31c3.08-1.17,5.31-3.84,7.21-6.53s3.69-5.56,6.35-7.49,6.54-2.66,9.21-.75",
    style: {
      fill: "#FF725E"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M360.51,376.53l-10.24-3.85,4.08.48a6.43,6.43,0,0,1,3.06,1.15Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M329.44,364.32c-10.69,6.45-10.66,12.32-8.87,17.86s8.35,9.39,13.78,7.31c3.08-1.17,5.31-3.84,7.21-6.53s3.69-5.56,6.35-7.49a9.41,9.41,0,0,1,6.38-1.81Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M321.44,371.39c2.79-3.86,9.7-5,14.06-3.05s7.55,5.74,10.41,9.56,5.64,7.84,9.6,10.5S365,392,369,389.34a11.56,11.56,0,0,0,4.56-7.91,26.43,26.43,0,0,0-.62-9.32c-.95-4.48-2.49-9.16-6.07-12-4-3.17-9.55-3.33-14.65-3.16-5.86.19-11.8.63-17.3,2.66s-11.1,6.41-13.43,11.79",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.39,438.62a.75.75,0,0,1,0-.24c0-.18,0-.41,0-.69,0-.64-.05-1.53-.09-2.65-.06-2.34-.16-5.67-.28-9.76s-.3-9-.59-14.46-.71-11.41-1.54-17.64a56.17,56.17,0,0,0-1.77-9,46.42,46.42,0,0,0-3.27-7.83,45.72,45.72,0,0,0-4.13-6.49,43.61,43.61,0,0,0-4.52-5,33.1,33.1,0,0,0-8-5.45c-.52-.24-1-.47-1.39-.64l-1-.4-.64-.26a.72.72,0,0,1-.21-.11,1.35,1.35,0,0,1,.23.06l.65.21,1.07.37c.42.15.88.37,1.41.6a32.11,32.11,0,0,1,8.15,5.37,42.33,42.33,0,0,1,4.6,5,44.9,44.9,0,0,1,4.21,6.52,45.93,45.93,0,0,1,3.33,7.91,56.38,56.38,0,0,1,1.8,9c.83,6.25,1.22,12.23,1.5,17.68s.4,10.35.49,14.47.12,7.46.13,9.77v2.65c0,.28,0,.51,0,.69A1.1,1.1,0,0,1,370.39,438.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.24,443.45a30.47,30.47,0,0,1-1.17-4.59,47.9,47.9,0,0,1-.49-12.9,85.34,85.34,0,0,1,4.07-18.71c2.19-6.88,5.17-14.23,7.72-22.14a101.28,101.28,0,0,0,3.06-11.71A103,103,0,0,0,389,362.22a161.93,161.93,0,0,0,.34-19.11c-.18-5.44-.47-9.84-.65-12.89l-.21-3.5c0-.38,0-.68,0-.91a1.19,1.19,0,0,1,0-.31,1.77,1.77,0,0,1,.05.3c0,.23.05.53.09.91.07.83.17,2,.29,3.5.24,3,.58,7.44.81,12.89a156.71,156.71,0,0,1-.24,19.16,101.54,101.54,0,0,1-1.5,11.23,99.75,99.75,0,0,1-3.07,11.77c-2.55,7.93-5.54,15.27-7.75,22.12A87.15,87.15,0,0,0,372.91,426a49.87,49.87,0,0,0,.34,12.83c.26,1.5.5,2.66.71,3.43.09.37.16.67.22.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400.74 448.28 350.55 448.28 349.4 438.62 400.74 438.62 400.74 448.28",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.93 447.18 362.21 476.16 389.48 476.16 395.35 447.18 355.93 447.18",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.74,448.28c0,.13-11,.21-24.65.17s-24.64-.18-24.64-.31,11-.21,24.64-.17S400.74,448.15,400.74,448.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.12,462.58a20.82,20.82,0,0,0-4.42-2.53,15.68,15.68,0,0,0-5.37-1.08,18.93,18.93,0,0,0-6.61,1.21c-2.29.78-4.43,1.68-6.51,2.17a15.45,15.45,0,0,1-5.62.17,11.7,11.7,0,0,1-3.61-1.14,7.51,7.51,0,0,1-.87-.56c-.19-.14-.28-.22-.27-.23s.42.25,1.22.62a12.75,12.75,0,0,0,3.58,1,15.82,15.82,0,0,0,5.48-.27c2-.5,4.14-1.41,6.45-2.19a18.67,18.67,0,0,1,6.77-1.2,15.14,15.14,0,0,1,5.49,1.21,14,14,0,0,1,3.27,1.9,8.31,8.31,0,0,1,.78.68C392.05,462.48,392.13,462.57,392.12,462.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.74,464.52a21.73,21.73,0,0,0-4.24-2.5,14.41,14.41,0,0,0-5.19-1.07,18.6,18.6,0,0,0-6.39,1.15c-2.21.74-4.29,1.6-6.27,2.13a16.24,16.24,0,0,1-5.4.61,9.15,9.15,0,0,1-3.54-.95,6.86,6.86,0,0,1-.85-.54c-.18-.13-.27-.21-.26-.22s.42.24,1.19.59a9.59,9.59,0,0,0,3.48.78,16.48,16.48,0,0,0,5.26-.69c1.94-.55,4-1.42,6.24-2.16a18.58,18.58,0,0,1,6.55-1.14,14.24,14.24,0,0,1,8.44,3.09,8.94,8.94,0,0,1,.75.66C391.67,464.42,391.75,464.51,391.74,464.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.62,460.66a23.24,23.24,0,0,0-4.54-2.67,16.57,16.57,0,0,0-5.51-1.33,17.92,17.92,0,0,0-6.82,1.2,59,59,0,0,1-6.73,2.2,16.86,16.86,0,0,1-5.81,0,13,13,0,0,1-3.73-1.18,6.12,6.12,0,0,1-.9-.56c-.2-.15-.3-.23-.29-.24s.45.26,1.27.63a14.25,14.25,0,0,0,3.7,1,17.32,17.32,0,0,0,5.67-.11,68.42,68.42,0,0,0,6.67-2.22,17.83,17.83,0,0,1,7-1.19,17,17,0,0,1,9,3.47,8.7,8.7,0,0,1,.8.7C392.54,460.56,392.63,460.65,392.62,460.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.18,448.32c0,.13-11.29.24-25.21.24s-25.22-.11-25.22-.24,11.29-.24,25.22-.24S401.18,448.19,401.18,448.32Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M468.52,476.16c0,.14-95.16.26-212.51.26s-212.53-.12-212.53-.26,95.14-.26,212.53-.26S468.52,476,468.52,476.16Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "152.06 463.88 149.05 419.56 173.03 421.81 171.03 464.78 159.24 465.44 152.06 463.88",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.37,461.68V463s-21.84,9-22,13.19l43.55-.66L172.08,461C165.65,464.12,158.88,464.56,151.37,461.68Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.74,465.72a1.78,1.78,0,0,1,1.26,2,1.71,1.71,0,0,1-2,1.27,1.89,1.89,0,0,1-1.33-2.14,1.78,1.78,0,0,1,2.21-1.09",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.89,475.5l-.2-3.48L131,473.92s-1.93.88-1.69,2.24Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M151.23,463.09c0,.22,1.07.3,2.13,1s1.63,1.55,1.82,1.46-.14-1.31-1.43-2.1S151.18,462.9,151.23,463.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.69,465.05c-.05.21.88.56,1.62,1.45s.95,1.83,1.17,1.82.33-1.22-.61-2.31S146.69,464.85,146.69,465.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.18,470.56c.19,0,.47-1-.09-2.18s-1.57-1.61-1.65-1.43.53.79,1,1.75S144,470.54,144.18,470.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.26 434.19 174.34 398.85 195.6 387.52 217.6 424.49 208.12 431.53 201.26 434.19",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.48,432.73l.72,1.07S186.94,453.37,189.07,457l36-24.53-8.65-11.64A24.93,24.93,0,0,1,199.48,432.73Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.37,427.09a1.79,1.79,0,0,1,2.16,1,1.72,1.72,0,0,1-1,2.15,1.87,1.87,0,0,1-2.28-1.05,1.77,1.77,0,0,1,1.24-2.13",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.05,432.42l-2.08-2.8-33.72,24.53s-1.13,1.79-.18,2.8Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M200.14,434c.13.17,1.06-.35,2.31-.37s2.21.4,2.33.22-.84-1-2.36-1S200,433.85,200.14,434Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.43,438.12c.08.2,1,0,2.14.32s1.82,1,2,.88-.39-1.2-1.77-1.59S197.32,438,197.43,438.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.37,444.1c.18-.07-.17-1.11-1.28-1.77s-2.19-.48-2.17-.28.89.37,1.79.92S198.18,444.2,198.37,444.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.66,282.1s-20.8,74.16-19.4,79.49,38.35,60.08,39.4,60.42,30.26-17.08,30.26-17.08l-30.26-49.88s16.85-36.07,21.76-52,5.86-16.75,2.81-31.26c-1.85-8.8-10.1-20.58-10.1-20.58l-1.33-4.07H158.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.21,247.13,134.74,257c-4.21,3-10.52,17.15-10.87,22.81s-1.71,28.92-1.75,45c-.06,18.64,20.66,129.34,20.66,129.34H180L166.91,278.44l-3.28-31.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.47,269.37a2.26,2.26,0,0,1-.06.42c-.06.3-.13.71-.23,1.23-.22,1.1-.54,2.68-.94,4.7-.87,4.08-2.17,10-3.88,17.21s-3.79,15.87-5.84,25.5c-1,4.81-2,9.88-2.84,15.17a118,118,0,0,0-1.59,16.46c-.09,5.65.35,11.24,2.32,16.22a120.85,120.85,0,0,0,6.48,14c4.64,8.67,9.33,16.21,13.44,22.41S173,413.74,175.55,417c1.3,1.63,2.3,2.89,3,3.7l.81.95a2,2,0,0,1,.26.34,62.89,62.89,0,0,1-4.27-4.86c-2.61-3.25-6.22-8.09-10.37-14.28s-8.87-13.71-13.55-22.39a117.31,117.31,0,0,1-6.54-14c-2-5-2.46-10.73-2.36-16.4a117.07,117.07,0,0,1,1.61-16.53c.81-5.3,1.84-10.37,2.87-15.19,2.08-9.63,4.21-18.24,5.95-25.48s3.11-13.11,4-17.17c.45-2,.79-3.59,1-4.69l.29-1.21A2.13,2.13,0,0,1,158.47,269.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.44,273.49a5.66,5.66,0,0,1-1.27.45,21.7,21.7,0,0,1-3.6.68,23.69,23.69,0,0,1-21.32-9.21,20.82,20.82,0,0,1-2-3.08,5.24,5.24,0,0,1-.54-1.23c.09-.06.88,1.7,2.8,4.08a24.38,24.38,0,0,0,21,9.07C200.59,274,202.41,273.38,202.44,273.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.2,258.09s0,.3-.17.82a17.39,17.39,0,0,1-.74,2.14,27.22,27.22,0,0,1-9.22,11.64,18.78,18.78,0,0,1-1.92,1.22,2.43,2.43,0,0,1-.76.35c0-.07,1-.69,2.46-1.86a31.39,31.39,0,0,0,9.1-11.5C138.75,259.18,139.12,258.06,139.2,258.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.56,116.44A6.52,6.52,0,0,0,195,105.69a7,7,0,0,0-7.6-9.14A7.48,7.48,0,0,0,177,90.16a7.21,7.21,0,0,0-11.46.46A8.6,8.6,0,0,0,162.08,92a5.39,5.39,0,0,0-3.36.5,14.93,14.93,0,0,0-3.46,2.63c-1.73,1.62-3.55,3.35-4.16,5.64-.69,2.55.22,5.47-1.07,7.78a18.15,18.15,0,0,0-1.66,2.63c-.65,1.86.61,3.86.46,5.83s-1.88,3.89-1.67,6a5.5,5.5,0,0,0,2.51,3.61,21.61,21.61,0,0,1,3.59,2.75c.8.91,1.31,2,2.1,2.95a6.76,6.76,0,0,0,9.22.72,7.22,7.22,0,0,0,6.52,1.14,21.15,21.15,0,0,0,6.11-3.12,4.18,4.18,0,0,0,7-.43,3.6,3.6,0,0,0,3.86,2.13,10.56,10.56,0,0,0,4.36-1.84c2.54-1.57,5.39-3.63,5.45-6.62,0-1.83-1-3.72-.31-5.41A10,10,0,0,1,199.56,116.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.87,104.52A18.88,18.88,0,0,1,156,96.77c7.25-1.23,15.31,0,21.2,4.4,5.4,4,8.4,10.69,9.24,17.39.29,2.36-.42,4.63-1.08,6.91a12.51,12.51,0,0,1-5.36,6.3c-2.11,1.11-3,.4-4.77-1.17a10.67,10.67,0,0,1-2.32-3.66c-2.56-5.59-5.49-11.13-9.8-15.52s-10.2-7.53-16.35-7.34",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.85,115.58c-.74-2-.42-4.23-.69-6.36-.61-4.67-4.25-8.62-8.65-10.34a20.67,20.67,0,0,0-13.86.08,19.23,19.23,0,0,0-8.78,5.56A14.66,14.66,0,0,0,140,117.65l23.92-3.17a26.57,26.57,0,0,0,7.18,4.85,4.78,4.78,0,0,0,2.49.43,2.21,2.21,0,0,0,1.87-1.51A4.72,4.72,0,0,0,174.85,115.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.06,105.54l20.78,4.69a3.89,3.89,0,0,1,3.59,3.85l-.83,45.11a14,14,0,0,1-3,8.47l-2,2.54a10.29,10.29,0,0,1-17.16-1.5,5.26,5.26,0,0,1-.46-1.19,7.09,7.09,0,0,1-.18-1,32.73,32.73,0,0,1-.28-6.83c-.15-4-.19-5.67-.19-5.63s-8.52-1.19-10.57-12.21c-1-5.48-1-14.51-.7-21.9C140.24,113.27,144.42,105,151.06,105.54Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.31,126.79a1.42,1.42,0,0,0,1.4,1.4,1.35,1.35,0,0,0,1.43-1.32,1.41,1.41,0,0,0-1.4-1.39A1.35,1.35,0,0,0,144.31,126.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.07,124.57c.18.18,1.24-.65,2.76-.68s2.67.7,2.83.5-.11-.41-.61-.75a3.87,3.87,0,0,0-2.26-.64,3.74,3.74,0,0,0-2.2.77C142.13,124.15,142,124.49,142.07,124.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.78,126.79a1.43,1.43,0,0,0,1.41,1.4,1.36,1.36,0,0,0,1.43-1.32,1.41,1.41,0,0,0-1.41-1.39A1.35,1.35,0,0,0,158.78,126.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.09,124.46c.18.18,1.23-.64,2.76-.68s2.67.7,2.83.51-.11-.41-.61-.76a3.9,3.9,0,0,0-2.27-.63,3.74,3.74,0,0,0-2.19.77C157.15,124,157,124.38,157.09,124.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.84,135.93a9.62,9.62,0,0,0-2.49-.38c-.39,0-.76-.1-.84-.37a2.12,2.12,0,0,1,.23-1.16c.35-1,.7-2,1.08-3,1.49-4.27,2.56-7.77,2.39-7.83s-1.52,3.35-3,7.62c-.36,1.05-.71,2.06-1,3a2.18,2.18,0,0,0-.16,1.53,1,1,0,0,0,.65.56,2.78,2.78,0,0,0,.67.07A10,10,0,0,0,151.84,135.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.26,154A28.21,28.21,0,0,0,166,149.69s-3.52,7.75-14.63,7Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.58,139.59a2.74,2.74,0,0,1,2.44-1.08,2.47,2.47,0,0,1,1.76.88,1.6,1.6,0,0,1,.17,1.82,1.86,1.86,0,0,1-2,.56,5.75,5.75,0,0,1-2-1.12,1.71,1.71,0,0,1-.45-.44.51.51,0,0,1,0-.57",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.36,136.87c-.25,0-.21,1.65-1.59,2.86s-3.16,1.08-3.17,1.31.4.31,1.15.31a4.06,4.06,0,0,0,2.64-1,3.58,3.58,0,0,0,1.24-2.39C156.67,137.26,156.48,136.86,156.36,136.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.71,119.85c.16.41,1.68.18,3.48.34s3.26.62,3.49.25c.1-.18-.16-.57-.76-1a6.08,6.08,0,0,0-5.3-.44C157,119.32,156.64,119.66,156.71,119.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.34,117.88c.28.34,1.32,0,2.59-.1s2.34.17,2.57-.2c.11-.18-.07-.52-.55-.84a3.58,3.58,0,0,0-2.11-.51,3.64,3.64,0,0,0-2.05.75C142.35,117.35,142.22,117.71,142.34,117.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.71,112.41c-2.08-6.37-11.41-15.14-18.09-14.63L150,104.27A10.31,10.31,0,0,0,157,112.1c1.89.57,4.17.71,5.3,2.32s.51,4.07,1.59,5.78c1.5,2.36,5.54,2.22,6.67,4.77.49,1.12.25,2.46.76,3.57.68,1.47,4.45,3.33,6,2.82s1.54-3.14,2-4.53a7.28,7.28,0,0,0,.19-4.91C178.86,118.8,179.7,115.46,178.71,112.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.86,107.65l-.82,3.52A14.1,14.1,0,0,0,180.2,104c-2.67-4-8.54-6.75-13.17-8.08s-10.32-.52-14.8,1.27a21,21,0,0,0-9.93,7.8c-3.4,4.6-4.19,11.53-2.09,12.76,1.66-4.77,4.29-10.24,8.46-13.1A17.36,17.36,0,0,1,163.1,102c5.4,1.59,9.51,6.16,11.9,11.25a43.87,43.87,0,0,1,2.71,8.11,20.88,20.88,0,0,1-.07,9.94l-2.7,9.45-.06,3.07c6.57-2.43,10.63-9.28,11.72-16.2S186.91,114,182.86,107.65Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.33,128.66c-.05,0,.18-.57.35-1.61a9.89,9.89,0,0,0-.34-4.39,9.38,9.38,0,0,0-3.81-5.14,28.53,28.53,0,0,0-3.5-1.74,10.39,10.39,0,0,1-3.56-2.42,15.92,15.92,0,0,1-2.07-3.76,9.41,9.41,0,0,0-8.23-5.43,9.94,9.94,0,0,0-4.31.88c-1,.44-1.43.8-1.45.76a1.48,1.48,0,0,1,.32-.28,7.09,7.09,0,0,1,1.05-.66,9.49,9.49,0,0,1,10.65,1.3,9.81,9.81,0,0,1,2.43,3.21,16.11,16.11,0,0,0,2,3.64,10.14,10.14,0,0,0,3.39,2.3,27.93,27.93,0,0,1,3.54,1.8,9.82,9.82,0,0,1,4.09,10,7.34,7.34,0,0,1-.36,1.19A1.49,1.49,0,0,1,177.33,128.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.32,116.81s-.24-.4-.81-1a10.15,10.15,0,0,0-2.93-1.8c-.66-.31-1.41-.64-2.17-1.09a6.49,6.49,0,0,1-2.14-1.87c-1.19-1.66-1.57-3.9-3.15-5.44a9.53,9.53,0,0,0-5.48-2.64,12.87,12.87,0,0,0-5,.41,36.55,36.55,0,0,0-4.42,1.73,5.22,5.22,0,0,1,1.08-.7,16.74,16.74,0,0,1,3.24-1.39,12.71,12.71,0,0,1,5.21-.52,9.75,9.75,0,0,1,5.79,2.75c1.71,1.69,2.08,4,3.17,5.52s2.8,2.23,4.08,2.91a8.92,8.92,0,0,1,2.91,2,3.46,3.46,0,0,1,.55.79C176.29,116.69,176.34,116.8,176.32,116.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.78,132.7c0-.82.88-2.79,1.69-2.94,2.16-.39,6.08-.32,6.26,5.2.25,7.54-7.37,6.23-7.39,6S172.84,135.55,172.78,132.7Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.55,138s.13.09.36.19a1.32,1.32,0,0,0,1,0,3.23,3.23,0,0,0,1.41-3,4.29,4.29,0,0,0-.43-1.87,1.52,1.52,0,0,0-1-1,.66.66,0,0,0-.76.39c-.1.21-.05.36-.09.37s-.16-.12-.11-.43a.87.87,0,0,1,.28-.48,1,1,0,0,1,.72-.22,1.84,1.84,0,0,1,1.41,1.13,4.48,4.48,0,0,1,.53,2.08c0,1.53-.73,3-1.81,3.32a1.39,1.39,0,0,1-1.21-.16C175.57,138.23,175.52,138.06,175.55,138Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.89,138.63a3.87,3.87,0,0,1,.35-.77c.24-.51.59-1.25.95-2.24a24.86,24.86,0,0,0,1.46-8.76,36.62,36.62,0,0,0-.64-6.13,38.13,38.13,0,0,0-1.8-6.82,25.65,25.65,0,0,0-3.78-6.78,25,25,0,0,0-6.16-5.58,23,23,0,0,0-15.43-3.41,22,22,0,0,0-6.72,2,21.39,21.39,0,0,0-5.06,3.44,22.28,22.28,0,0,0-5.21,7.16c-.42,1-.7,1.74-.87,2.27a6.59,6.59,0,0,1-.28.8,4.34,4.34,0,0,1,.18-.83,19.35,19.35,0,0,1,.79-2.32,21.66,21.66,0,0,1,10.26-10.91,22.12,22.12,0,0,1,6.85-2.09,23.25,23.25,0,0,1,15.77,3.44,25.06,25.06,0,0,1,10.1,12.63,37.8,37.8,0,0,1,1.79,6.92,36.89,36.89,0,0,1,.58,6.2,23.82,23.82,0,0,1-1.64,8.83,22.51,22.51,0,0,1-1,2.21A5.69,5.69,0,0,1,181.89,138.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.69,140c.1-.14.34-.2.68,0a1.89,1.89,0,0,1,.91,1.21,2.52,2.52,0,0,1,.05,1.14,2.62,2.62,0,0,1-.63,1.27,3.1,3.1,0,0,1-5.2-1,2.9,2.9,0,0,1,.08-2.36,1.8,1.8,0,0,1,1.25-1c.41-.06.61.13.63.3a1.79,1.79,0,0,1-.11.57,2.27,2.27,0,0,0,0,.7,2,2,0,0,0,.34.76,1.07,1.07,0,0,0,.62.41,1.18,1.18,0,0,0,.73-.11.83.83,0,0,0,.43-.52C178.66,140.82,178.49,140.29,178.69,140Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.51,187.24s1.25-10,6.1-15.07,25.79-11.52,25.79-11.52.14,7.38,5,9.11c5.14,1.83,10.14.86,13.91-3.51a20.41,20.41,0,0,0,4.35-9.5s25.36,2.35,29.3,9S213,198.06,213,198.06l-22.62,4.8,3.08,44.27h-60.1l1.18-41.54-16.37,2.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.89,204.32a4.13,4.13,0,0,1-.08-1c0-.65,0-1.58,0-2.72,0-2.3,0-5.47.11-9s.16-6.67.26-9c.05-1.15.09-2.08.14-2.72a3.46,3.46,0,0,1,.12-1,3.68,3.68,0,0,1,.08,1c0,.64,0,1.57,0,2.72,0,2.29,0,5.46-.11,9s-.17,6.67-.27,9c0,1.15-.09,2.08-.13,2.72A3.42,3.42,0,0,1,185.89,204.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,186.1c.14,0,1.55,4.45,3.16,10s2.79,10.14,2.65,10.17a104.19,104.19,0,0,1-3.15-10C130,190.69,128.83,186.14,129,186.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.43,164.14c0,.09-1.08.29-2.73.92a19.56,19.56,0,0,0-10.17,8.85c-.85,1.55-1.2,2.6-1.29,2.57a2.57,2.57,0,0,1,.17-.77,12.44,12.44,0,0,1,.79-2,17.94,17.94,0,0,1,10.38-9,13.77,13.77,0,0,1,2.07-.51C201.15,164.13,201.42,164.1,201.43,164.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.24,174.2a10.76,10.76,0,0,1,1.06,3.12,10.52,10.52,0,0,1,.56,3.25,21,21,0,0,1-1.62-6.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,198.92s-6.78,34.4-7.55,37.34-2,10.87-10.23,12.51c-11.08,2.21-54.57.67-54.57.67l8.2-10.39,38.06-10.67,5.2-25Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.7,192.53s6.13,20.63,8.67,29.55c2.71,9.47,8.61,31,21.21,27.17,9.58-2.91,6.76-15.33,6.76-15.33l-9.8-28.33-7.63,1.27-7.4-19.11Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,234.81a10.72,10.72,0,0,0,0-4.66,14.51,14.51,0,0,0-2-4.64,41.54,41.54,0,0,0-4-4.88,40.84,40.84,0,0,1-4-4.95,32.07,32.07,0,0,1-2.51-4.56,28.87,28.87,0,0,1-1.22-3.28,5.29,5.29,0,0,1-.3-1.25,7.64,7.64,0,0,1,.49,1.18c.3.77.73,1.87,1.37,3.19a34,34,0,0,0,2.57,4.45,44.53,44.53,0,0,0,4,4.88,37.76,37.76,0,0,1,4,5,14.07,14.07,0,0,1,2,4.82,9.27,9.27,0,0,1,.05,3.52,6,6,0,0,1-.27.92C141.05,234.72,141,234.82,141,234.81Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.48,153.77s1-1.4,3.47.76,12.46,19.13,13.24,20.69,5.32,12.53,5.32,12.53l-10.12,7.17-1.69-2.39s-8.49-7.53-10.22-9.61a46.39,46.39,0,0,1-4.15-5.54c-.09-.43-.69-2.62,1-3.26,0,0-1.65-2.62-.18-3.92s4.16-.09,4.16-.09l-9-11.6s-.78-3.46,1.82-2.16,9.43,11.25,10.64,11.51,1.21-1,1.21-1S95.93,156.13,97.48,153.77Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.74,184.22s-.1-.16-.21-.48a6.47,6.47,0,0,1-.34-1.45,6.64,6.64,0,0,1,1.35-5.14v.28c-.91-1.1-1.9-2.32-3-3.61l.07.06c-.71-.41-1.44-.86-2.17-1.34l-1.11-.76a7.43,7.43,0,0,1-1.09-.9,1.88,1.88,0,0,1-.54-1.21,1.61,1.61,0,0,1,.54-1.22l.09-.1.14,0,6.23,1.77h0l0,0,4.9,3.65a14,14,0,0,1,1.8,1.47,18.09,18.09,0,0,1-1.95-1.25l-5-3.51.07,0-6.24-1.7.23,0a1.14,1.14,0,0,0-.35.82,1.41,1.41,0,0,0,.41.87,7.1,7.1,0,0,0,1,.83l1.08.75c.72.48,1.44.93,2.14,1.33l0,0,0,0c1,1.32,2,2.55,2.91,3.66l.11.14-.12.14a6,6,0,0,0-1.27,2.58,7.17,7.17,0,0,0-.15,2.24C106.55,183.52,106.8,184.2,106.74,184.22Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.46,170.68a5.78,5.78,0,0,1,.85,1,24.81,24.81,0,0,1,1.93,3.07,22.49,22.49,0,0,1,1.08,2.29,2.54,2.54,0,0,1,.14,1.49,1.53,1.53,0,0,1-1.22,1.1,2.43,2.43,0,0,1-1.65-.27,6.78,6.78,0,0,1-1.38-.95A13.24,13.24,0,0,1,96,175.81c-.37-.53-.7-1.07-1-1.58l.41-.3a24,24,0,0,1,3.3,4.95,2.83,2.83,0,0,1,.32,1.38,1.58,1.58,0,0,1-.67,1.21,1.47,1.47,0,0,1-1.29.05,3.49,3.49,0,0,1-.93-.61,15.86,15.86,0,0,1-2.16-2.36,4.13,4.13,0,0,1-.61-1,33.24,33.24,0,0,0,3,3.08c.48.39,1.21.83,1.78.47a1.16,1.16,0,0,0,.45-.89,2.48,2.48,0,0,0-.29-1.15A25.74,25.74,0,0,0,95,174.26l.42-.3c.31.5.65,1,1,1.56a13.35,13.35,0,0,0,2.15,2.53c.8.67,1.73,1.33,2.6,1.14a1.1,1.1,0,0,0,.88-.76,2.18,2.18,0,0,0-.11-1.23c-.3-.81-.67-1.58-1-2.26a31.63,31.63,0,0,0-1.77-3.12A6.76,6.76,0,0,1,98.46,170.68Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.11,233.24a2.54,2.54,0,0,1,.33.8,11.31,11.31,0,0,1,.44,2.29,13.27,13.27,0,0,1-1.56,7.49,15.2,15.2,0,0,1-2.49,3.45,8.33,8.33,0,0,1-2.9,1.94,7.94,7.94,0,0,1-2.29.51,2.17,2.17,0,0,1-.86,0,17.27,17.27,0,0,0,3-.82,8.72,8.72,0,0,0,2.7-1.93,16.64,16.64,0,0,0,2.38-3.37,13.9,13.9,0,0,0,1.64-7.22C144.42,234.42,144,233.27,144.11,233.24Z",
    style: {
      fill: "#aa6550"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.4fe7517167a2b859c41f385d3c0432f2.svg";
export { ForwardRef as ReactComponent };